import React from "react";
import image from "@ugitgud/legos/assets/lib/shared/icon/allstar/allstar-logo-purple.webp";
import { Image, ImageProps } from "@ugitgud/legos/ui/util/Image";

export const AllstarLogoPurpleIcon: React.FC<ImageProps & { mono?: string }> = (props) => {
  return <Image src={image} {...props} />;
};
